import { useState } from "react";
import { defaultUserContext } from "./defaultUserContext";
import { IUserProps, IUseUserQueryResultResult, useUserQuery } from ".";
import { useTranslation } from "react-i18next";
import { useOnce } from "lib/common/use-once";
import { IUser } from "services/security/interfaces";

export function useUserQueryResult({ userId }: IUserProps): IUseUserQueryResultResult {
  const { i18n } = useTranslation();
  const [userResult, setUserResult] = useState(defaultUserContext.userResult);
  const { query } = useUserQuery({ userId });

  useOnce(async () => {
    const data = query.data?.data;
    const { status, isError, isLoading, isSuccess, error } = query;

    await i18n.changeLanguage(data?.user_profile.user_lang);

    setUserResult({
      status,
      isError,
      isLoading,
      isSuccess,
      error,
      data: data as Partial<IUser>
    });
  }, query.isSuccess);

  useOnce(() => {
    const { status, isError, isLoading, isSuccess, error } = query;

    setUserResult({
      status,
      isError,
      isLoading,
      isSuccess,
      error,
      data: userResult.data // default
    });
  }, query.isError);

  return {
    userResult
  };
}
